import React from "react";

export default props => {
    return (
        <div id={props.anchor}>
            <h2>PRIVACY STATEMENT </h2>
            Last revised: 20 April 2018
            <br />
            <h3>Introduction</h3>
            <p>
                Welcome to the due diligence platform website (this
                &quot;Platform&quot;). This Privacy Statement applies to the
                entity within the Deloitte Network that invited you to use this
                Platform, and it describes the ways in which your personal
                information is collected in connection with your use of this
                Platform, the purposes for which your personal information is
                used, and how it is shared.
            </p>
            <p>
                Please note that this Privacy Statement covers the personal
                information that is collected in connection with your use of
                this Platform only. Any information uploaded to or posted on
                this Platform will be used in accordance with the terms of the
                relevant engagement letter or this Platform&#39;s Terms of Use,
                as applicable and may also be read or used by other authorized
                users who have been granted access to the Deloitte Online
                collaboration spaces to which you have access.
            </p>
            <p>
                This Platform may contain links to other sites, including,
                without limitation, sites maintained by entities within the
                Deloitte Network, which may not be governed by this Privacy
                Statement. Users of this Platform are encouraged to review each
                website&#39;s privacy statement before disclosing any personal
                information.
            </p>
            <p>
                The &quot;Deloitte Network&quot; means Deloitte LLP
                (&quot;DLLP&quot;), and its subsidiaries. To learn more about
                Deloitte&#39;s global network of member firms, please visit{" "}
                <a href="www.deloitte.com/about">www.deloitte.com/about</a>.
            </p>
            <h3>Information Collection and Use</h3>
            <p>
                In order to register and gain access to the Platform, users may
                be asked to provide their full name, email address and location.
                This information is used to verify your identity each time you
                log in to the Platform. You may also be requested to submit
                additional information such as telephone number, the name of
                your company and your professional position. This information
                will be used to manage your account and customize and improve
                the Platform.
            </p>
            <p>
                Use of this application may be subject to review, monitoring and
                recording at any time to enable help us ensure compliance with
                the Terms of Use and that only authorised parties are accessing
                Deloitte Online using your user login and password.
            </p>
            <h3>Legal Basis for Information Processing</h3>
            <p>
                Your personal information will be used for the purposes outlined
                above because: (a) one or more entities within the Deloitte
                Network have a legitimate interest in the effective delivery of
                services to you or a client of an entity/entities within the
                Deloitte Network; (b) the information is required in order to
                provide services to you or a client of an entity/entities within
                the Deloitte Network; or (c) one or more entities within the
                Deloitte Network are subject to legal or regulatory obligations,
                such as providing information to a public body or law
                enforcement agency.
            </p>
            <p>Log Information, Cookies and Web beacons</p>
            <p>
                This Platform collects standard internet log information,
                including a user’s IP address, browser type and language, access
                time, and referring website address.
            </p>
            <p>
                This Platform also uses cookies (small text files stored on a
                user’s device) to identify users when they connect to the site.
                A user’s browser must be enabled to allow cookies in order to
                access this Platform. Upon successful login, cookies are created
                and placed on the user’s machine. In addition to information
                related to authentication, information may be stored in the
                cookies in order to direct a user to the correct site location.
                To ensure that this Platform is well managed and to facilitate
                improved navigation, cookies or web beacons (electronic images
                that allow a website to count visitors who have accessed a
                particular page and access certain cookies) may be used to
                collect aggregate data.
            </p>
            <p>
                Most browsers can be set to inform you when a cookie has been
                sent to you and provide you with the opportunity to reject that
                cookie. However, in some cases, refusing a cookie may preclude
                you from using or negatively impact the display or function of
                this Platform or certain areas or features of this Platform.
            </p>
            <p>
                By using this Platform, you agree that cookies can be placed on
                your computer or device as explained above. Please send an email
                to DOL Response Centre if you would like more detailed
                information on the cookies used by this Platform
            </p>
            <h3>Disclosure of Information to Third Parties</h3>
            <p>
                In connection with one or more of the purposes outlined in the
                “Information Collection and Use” section above, your personal
                information may be disclosed to:
            </p>
            <ul>
                <li>other entities within the Deloitte Network;</li>
                <li>
                    third parties that provide services to one or more entities
                    within the Deloitte Network, such as website and system
                    hosting, management, and support;
                </li>
                <li>
                    other entities within the Deloitte Network and other third
                    parties as part of a corporate transaction, such as a
                    divesture, reorganization, merger, or acquisition; and
                </li>
                <li>
                    competent authorities, including courts and authorities
                    regulating one or more entities within the Deloitte Network,
                    in each case to comply with legal or regulatory obligations
                    or requests.
                </li>
            </ul>
            <p>
                Please note that this Platform is hosted in the United States.
                Additionally, some of the recipients of your personal
                information referenced above may be based in countries or
                regions outside of your home jurisdiction. Accordingly, any
                personal information that is collected in connection with your
                use of this Platform may be transferred to countries or regions
                without data protection rules similar to those in effect in your
                home jurisdiction.
            </p>
            <p>
                In such cases, adequate safeguards designed to protection your
                personal information will be put in place. Where the recipient
                is located outside of the European Economic Area
                (&quot;EEA&quot;), the adequate safeguard might be a data
                transfer agreement with the recipient based on standard
                contractual clauses approved by the European Commission for
                transfers of personal information to third countries.
            </p>
            <p>
                For further details on the transfers described above and the
                adequate safeguards used with respect to such transfers, please
                send an email to jraskin@deloitte.com or Jleonard@deloitte.com.
            </p>
            <h3>Information Security</h3>
            <p>
                Reasonable commercial standards of technology and operational
                security are in place and designed to protect your personal
                information from loss, misuse, and unauthorized access,
                disclosure, alteration, and destruction.
            </p>
            <h3>Information Retention</h3>
            <p>
                Your personal information will be retained as long as is
                necessary for the fulfillment of the purposes identified in the
                “Information Collection and Use” section above or as otherwise
                necessary to comply with applicable laws or professional
                standards. Where personal information is no longer necessary or
                relevant for our identified purposes, your personal information
                will be disposed of securely.
            </p>
            <h3>Your Rights</h3>
            <p>
                You have various rights in relation to your personal
                information. In particular, you have a right to:
            </p>
            <ul>
                <li>
                    obtain confirmation that your personal information is being
                    processed, and request a copy of your personal information;
                    and
                </li>
                <li>
                    ask that the personal information held about you be
                    corrected or supplemented if such information is inaccurate
                    or incomplete.
                </li>
            </ul>
            <p>
                Depending on the jurisdiction in which you are located, you may
                also have the right to:
            </p>
            <ul>
                <li>
                    ask that the personal information held about you be deleted,
                    or restrict the way in which such information is used; and
                </li>
                <li>object to the processing of your personal information.</li>
            </ul>
            <p>
                If you are interested in exercising any of the abovementioned
                rights or would like to raise a question about the processing of
                your personal information, please send an email to{" "}
                <a href="mailto:thejraskin@deloitte.com">
                    thejraskin@deloitte.com
                </a>{" "}
                or
                <a href="mailto:Jleonard@deloitte.com">Jleonard@deloitte.com</a>
                .
            </p>
            <p>
                You may also use the above listed contact details if you wish to
                make a complaint relating to your personal information or
                privacy.
            </p>
            <p>
                If you are located in the EEA and are unsatisfied with the way
                in which your personal information has been processed or the
                manner in which a privacy query or request that you have raised
                has been handled, you may have a right to complain to the
                relevant Data Protection Authority (&quot;DPA&quot;). For
                additional information or to be directed to the appropriate DPA,
                please send an email to the{" "}
                <a href="mailto:thejraskin@deloitte.com">
                    thejraskin@deloitte.com
                </a>{" "}
                or
                <a href="mailto:Jleonard@deloitte.com">Jleonard@deloitte.com</a>
                .
            </p>
            <h3>Changes to this Privacy Statement</h3>
            <p>
                This Privacy Statement may be modified or amended from time to
                time. When changes are made to this Privacy Statement, the
                revision date at the top of this page will be amended, and such
                modified or amended privacy statement shall be effective as to
                you and your information as of that revision date. As a user of
                this Platform, you are encouraged to review this Privacy
                Statement periodically to be informed about how your personal
                information is protected.
            </p>
            <h3>Questions</h3>
            <p>
                If you have any questions regarding this Privacy Statement or
                your personal information or would like additional information,
                please send an email to{" "}
                <a href="mailto:thejraskin@deloitte.com">
                    thejraskin@deloitte.com
                </a>{" "}
                or
                <a href="mailto:Jleonard@deloitte.com">Jleonard@deloitte.com</a>
                .
            </p>
        </div>
    );
};
